export const burgerMenuList = [
  { name: 'Связаться', route: '/contact-us' },
  { name: 'Все материалы', route: '/articles' },
  { name: 'Новости', route: '/news' },
  {
    name: 'Что происходит?',
    route: '/themes/what-is-happening',
  },
  { name: 'Что делать?', route: '/themes/what-can-I-do' },
  { name: 'Что нужно знать?', route: '/themes/what-should-I-know' },
  { name: 'Как отвлечься?', route: '/themes/take-your-mind-off' },
  { name: 'Рассылка', route: '/antiwarletter' },
];
